import {  logEvent } from "firebase/analytics";
import { analytics } from "@/lib/firebase";
import useAuthStore from "@/lib/useAuthStore";


export const logFirebaseEvent = (eventName: string, params?: any) => {
    try {
      // Get the current state from the auth store
      const { user} = useAuthStore.getState();
      

      let userData = user;

      const finalParams = {
        ...params,
        userId: userData?.id || null,
        userName: userData?.username || null,
        roleType: userData?.role_type || null,
        timeStamp: new Date().getTime().toString(),
      };
  
      logEvent(analytics, eventName, finalParams);
      console.log(`✅ Event Logged: ${eventName}`, finalParams);
    } catch (error) {
      console.error("❌ Error logging Firebase event:", error);
    }
  };